import { VisuallyHidden } from '@chakra-ui/react';
import { Button, type ButtonProps } from '@time-line/components/common';
import { Amazon } from '@time-line/components/icons';

interface ProductBuyOnAmazonProps extends ButtonProps {
  asin?: string;
  overrideUrl?: string;
  variant?: 'primary' | 'outline';
  size: 'sm' | 'md';
  colorScheme?: 'white' | 'gray';
}

export const ProductBuyOnAmazonButton = ({
  asin,
  overrideUrl,
  variant = 'outline',
  colorScheme = 'gray',
  ...props
}: ProductBuyOnAmazonProps) => {
  const href = `https://www.amazon.com/dp/${asin}`;
  const isWhite = colorScheme === 'white';

  const styles = {
    primary: {
      '> * > .chakra-icon': {
        'path:first-of-type': {
          fill: isWhite ? 'gray.600' : 'gray.50',
          transitionDuration: 'normal',
          transitionProperty: 'common',
        },
      },
      _hover: {
        bgColor: 'transparent',
        color: isWhite ? 'gray.50' : 'gray.600',
        svg: {
          'path:first-of-type': {
            fill: isWhite ? 'gray.50' : 'gray.600',
          },
        },
      },
    },
    outline: {
      _hover: {
        bgColor: 'blackAlpha.50',
      },
    },
  } as const;

  return (
    <Button
      className="button--amazon"
      as="a"
      href={overrideUrl ?? href}
      target="_blank"
      rel="noreferrer noopener"
      variant={variant}
      sx={styles[variant]}
      colorScheme={colorScheme}
      {...props}
    >
      Buy on <VisuallyHidden>Amazon</VisuallyHidden>
      <Amazon width="52px" pos="relative" top="3px" />
    </Button>
  );
};
